module.exports = __webpack_public_path__ + "img/crypto_on.08fb74c3.png";